// extracted by mini-css-extract-plugin
export default {"connection":"Historics_connection__fDVGX"};